import React from "react";
import { SideBar } from "./../../sidebar";
import swal from "sweetalert";
import { getAuction, upsertVehicle } from "../../../../models/auctions";
import { AuctionTabs } from "./../../helper/auction_tabs";
import { Spinner } from "react-bootstrap";
import i18n from "../../../../i18n";
import HeaderBanner from "../../../common/HeaderBanner";
import "../../../../styles/components/create-group.scss";
import {
  AlertTriangle,
  ArrowLeft,
  Expand,
  Loader2,
  Shrink,
} from "lucide-react";

export class AuctionVehicle extends React.Component {
  constructor() {
    super();
    let path = window.location.pathname;
    let auctionId = path.substring(path.lastIndexOf("/") + 1, path.length);
    this.state = {
      auction: {},
      is_loading: false,
      is_saving: false,
      auctionId: auctionId,
      input: {
        auction: auctionId,
        vehicle_number: "",
        make: "",
        model: "",
        model_ar: "",
        mileage: "",
        mileage_ar: "",
        information_number: "",
        transmission_type: "",
        transmission_type_ar: "",
        extras: "",
        body_type: "",
        body_type_ar: "",
        fuel_type: "",
        fuel_type_ar: "",
        warranty: "",
        color: "",
        color_ar: "",
        engine_size: "",
        no_of_keys: "",
        document_type: "",
      },
      errors: {},
      hideSidebar: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    this.loadAuction();
  }

  handleChange(event) {
    let { input } = this.state;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  async loadAuction() {
    this.setState({ is_loading: true });
    const response = await getAuction(this.state.auctionId);
    if (response) {
      let auction = response.data;
      this.setState({ auction });
      if (auction?.vehicle_info) {
        this.setState({ input: auction?.vehicle_info });
      }
      this.setState({ is_loading: false });
    }
  }

  async submitForm() {
    let { input } = this.state;
    this.setState({ is_saving: true });
    const response = await upsertVehicle({ ...input });
    if (response.success) {
      this.setState({ input: response.data });
      this.setState({ is_saving: false });
    } else {
      this.setState({ is_saving: false });
    }
  }

  render() {
    let { auction, is_loading } = this.state;
    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t("vehicle") || "Vehicle"}
          subtitle={
            i18n.t("manage_vehicle_subtitle") ||
            "Manage vehicle information"
          }
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? "col-xl-12 col-lg-12 col-md-12"
                    : "col-xl-9 col-lg-12 col-md-12"
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{
                          fontSize: "1rem",
                          marginRight: "0.5rem",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          })
                        }
                      >
                        {this.state.hideSidebar && <Shrink strokeWidth={1} />}
                        {!this.state.hideSidebar && <Expand strokeWidth={1} />}
                      </span>
                    </div>
                    <div className="header-action">
                      <button
                        className="button1 button1-gradient button1-back"
                        onClick={() => window.history.back()}
                      >
                        <ArrowLeft size={18} className="icon" />
                        <span>{i18n.t("back")}</span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <AuctionTabs activeTab="vehicle" />
                    <div className="create-group-container">
                      {/* Loading State */}
                      {is_loading && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "3rem",
                            background: "#f9fafb",
                            borderRadius: "8px",
                          }}
                        >
                          <Loader2
                            className="animate-spin"
                            size={24}
                            style={{ marginRight: "8px" }}
                          />
                          <span>{i18n.t("loading") || "Loading..."}</span>
                        </div>
                      )}

                      {/* Not a vehicle auction */}
                      {!is_loading && !auction?.is_vehicle && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            padding: "16px 20px",
                            background: "#fef2f2",
                            border: "1px solid #fecaca",
                            borderRadius: "8px",
                            color: "#991b1b",
                          }}
                        >
                          <AlertTriangle size={20} />
                          <span>This is not a vehicle auction</span>
                        </div>
                      )}

                      {/* Vehicle Form */}
                      {!is_loading && auction?.is_vehicle && (
                        <div className="form-content">
                          {/* LEFT COLUMN */}
                          <div className="left-column">
                            <div className="form-section">
                              <h2>
                                {i18n.t("vehicle") || "Vehicle"}{" "}
                                {i18n.t("details") || "Details"}
                              </h2>

                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t("number")}</label>
                                  <input
                                    type="text"
                                    name="vehicle_number"
                                    placeholder={i18n.t("number")}
                                    value={this.state.input.vehicle_number}
                                    onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-field">
                                  <label>{i18n.t("make")}</label>
                                  <input
                                    type="text"
                                    name="make"
                                    placeholder={i18n.t("make")}
                                    value={this.state.input?.make}
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>

                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t("model")}</label>
                                  <input
                                    type="text"
                                    name="model"
                                    placeholder={i18n.t("model")}
                                    value={this.state.input?.model}
                                    onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-field">
                                  <label>
                                    {i18n.t("model")}({i18n.t("arabic")})
                                  </label>
                                  <input
                                    type="text"
                                    name="model_ar"
                                    placeholder={i18n.t("model")}
                                    value={this.state.input?.model_ar}
                                    onChange={this.handleChange}
                                    dir="rtl"
                                  />
                                </div>
                              </div>

                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t("mileage")}</label>
                                  <input
                                    type="text"
                                    name="mileage"
                                    placeholder={i18n.t("mileage")}
                                    value={this.state.input?.mileage}
                                    onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-field">
                                  <label>
                                    {i18n.t("mileage")}({i18n.t("arabic")})
                                  </label>
                                  <input
                                    type="text"
                                    name="mileage_ar"
                                    placeholder={i18n.t("mileage")}
                                    value={this.state.input?.mileage_ar}
                                    onChange={this.handleChange}
                                    dir="rtl"
                                  />
                                </div>
                              </div>

                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t("transmission_type")}</label>
                                  <input
                                    type="text"
                                    name="transmission_type"
                                    placeholder={i18n.t("transmission_type")}
                                    value={this.state.input?.transmission_type}
                                    onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-field">
                                  <label>
                                    {i18n.t("transmission_type")}(
                                    {i18n.t("arabic")})
                                  </label>
                                  <input
                                    type="text"
                                    name="transmission_type_ar"
                                    placeholder={i18n.t("transmission_type")}
                                    value={
                                      this.state.input?.transmission_type_ar
                                    }
                                    onChange={this.handleChange}
                                    dir="rtl"
                                  />
                                </div>
                              </div>

                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t("body_type")}</label>
                                  <input
                                    type="text"
                                    name="body_type"
                                    placeholder={i18n.t("body_type")}
                                    value={this.state.input?.body_type}
                                    onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-field">
                                  <label>
                                    {i18n.t("body_type")}({i18n.t("arabic")})
                                  </label>
                                  <input
                                    type="text"
                                    name="body_type_ar"
                                    placeholder={i18n.t("body_type")}
                                    value={this.state.input?.body_type_ar}
                                    onChange={this.handleChange}
                                    dir="rtl"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* RIGHT COLUMN */}
                          <div className="right-column">
                            <div className="form-section">
                              <h2>
                                {i18n.t("specifications") || "Specifications"}
                              </h2>

                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t("fuel_type")}</label>
                                  <input
                                    type="text"
                                    name="fuel_type"
                                    placeholder={i18n.t("fuel_type")}
                                    value={this.state.input?.fuel_type}
                                    onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-field">
                                  <label>
                                    {i18n.t("fuel_type")}({i18n.t("arabic")})
                                  </label>
                                  <input
                                    type="text"
                                    name="fuel_type_ar"
                                    placeholder={i18n.t("fuel_type")}
                                    value={this.state.input?.fuel_type_ar}
                                    onChange={this.handleChange}
                                    dir="rtl"
                                  />
                                </div>
                              </div>

                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t("color")}</label>
                                  <input
                                    type="text"
                                    name="color"
                                    placeholder={i18n.t("color")}
                                    value={this.state.input?.color}
                                    onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-field">
                                  <label>
                                    {i18n.t("color")}({i18n.t("arabic")})
                                  </label>
                                  <input
                                    type="text"
                                    name="color_ar"
                                    placeholder={i18n.t("color")}
                                    value={this.state.input?.color_ar}
                                    onChange={this.handleChange}
                                    dir="rtl"
                                  />
                                </div>
                              </div>

                              <div className="form-row">
                                <div className="form-field">
                                  <label>
                                    {i18n.t("information_number")}
                                  </label>
                                  <input
                                    type="text"
                                    name="information_number"
                                    placeholder={i18n.t("information_number")}
                                    value={
                                      this.state.input?.information_number
                                    }
                                    onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-field">
                                  <label>{i18n.t("warranty")}</label>
                                  <input
                                    type="text"
                                    name="warranty"
                                    placeholder={i18n.t("warranty")}
                                    value={this.state.input?.warranty}
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>

                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t("engine_size")}</label>
                                  <input
                                    type="text"
                                    name="engine_size"
                                    placeholder={i18n.t("engine_size")}
                                    value={this.state.input?.engine_size}
                                    onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-field">
                                  <label>{i18n.t("no_of_keys")}</label>
                                  <input
                                    type="text"
                                    name="no_of_keys"
                                    placeholder={i18n.t("no_of_keys")}
                                    value={this.state.input?.no_of_keys}
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>

                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t("document_type")}</label>
                                  <input
                                    type="text"
                                    name="document_type"
                                    placeholder={i18n.t("document_type")}
                                    value={this.state.input?.document_type}
                                    onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-field">
                                  <label>{i18n.t("extras")}</label>
                                  <input
                                    type="text"
                                    name="extras"
                                    placeholder={i18n.t("extras")}
                                    value={this.state.input?.extras}
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Action Buttons */}
                      {!is_loading && auction?.is_vehicle && (
                        <div className="action-buttons-l2 border-top-light">
                          <button
                            className="button1 button1-gray"
                            onClick={() => window.history.back()}
                            type="button"
                            disabled={this.state.is_saving}
                          >
                            {i18n.t("cancel")}
                          </button>
                          <button
                            className="button1 button1-primary"
                            onClick={(e) => {
                              this.submitForm(e);
                            }}
                            type="button"
                            disabled={this.state.is_saving}
                          >
                            {this.state.is_saving ? (
                              <>
                                <Loader2 className="animate-spin" size={18} />
                                <span>{i18n.t("submit")}</span>
                              </>
                            ) : (
                              <span>{i18n.t("submit")}</span>
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}